import axios from "axios";
import { aspNetUrl } from "../../axiosInstance";

export const LinkedProducts = (data) => {
  return axios.post(`${aspNetUrl}LinkedProducts`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const LinkedProductsRemove = (data) => {
  return axios.post(`${aspNetUrl}LinkedProducts/remove`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
